import { bffInstance } from "../api/axiosInstance";
import { useQuery } from "react-query";

export const fetchChannelMessageApps = async () => {
  const response = await bffInstance.get(`/getChannelMsgApps`);
  return response.data;
};

export function useChannelMessageApps() {
  const { data } = useQuery({
    queryKey: ["getChannelMsgApps"],
    queryFn: fetchChannelMessageApps,
  });

  return { data };
}
